import _ from 'lodash';
import logUtils from '../HelperMethods/LogUtils';
import apiService from '../service/apiService';
import * as UserUtilites from '../HelperMethods/UserUtilities';
import { loadAllTeams, types as teamActionTypes } from './teamActions';
import { loadAllTaskTypes, types as taskTypeActionTypes } from './taskTypeActions';
import { loadGlobalAttributes } from '../components/generalConfig/attributeManagement/redux/reducer';
import { getFieldsAndAreasAccessibleToUser } from '../HelperMethods/UserUtilities';
// eslint-disable-next-line import/no-cycle
import { loadUsersForField, loadSavedFiltersOfUser } from '../components/taskView/TaskViewPage/redux/actions';
// eslint-disable-next-line import/no-cycle
import { changeSelectedFilter } from '../reducers/appReducer';
import {
  setSelectedFieldInLocalStorage,
  getSelectedFieldInLocalStorage,
  setSelectedAreasInLocalStorage,
  getSelectedAreasInLocalStorage,
  getSelectedTaskTypeGroupsInLocalStorage,
  setSelectedTaskTypeGroupsInLocalStorage,
  makeInitialUserConfig,
} from '../HelperMethods/LocalStorageUtils';

import { LOCAL_STORAGE_TASK_LIST_FILTER_MODEL } from '../HelperMethods/AgGridConstants';
import { STATUS_LIST } from '../HelperMethods/enums';

export const types = {
  SET_TENANT_ID: 'SET_TENANT_ID',
  FIELD_CHANGED: 'FIELD_CHANGED',
  AREAS_SELECTED: 'AREAS_SELECTED',
  LOAD_FIELDS_SUCCESS: 'LOAD_FIELDS_SUCCESS',
  SET_LOGGED_IN_USER: 'SET_LOGGED_IN_USER',
  SETTINGS_LOADED: 'SETTINGS_LOADED',
  PACKAGES_INFO_LOADED: 'PACKAGES_INFO_LOADED',
  SETTINGS_UPDATED: 'SETTINGS_UPDATED',
  LOADING_INITIAL_DATA: 'LOADING_INITIAL_DATA',
  HIDE_LOADER: 'HIDE_LOADER',
  SHOW_ERROR_MESSAGE: 'SHOW_ERROR_MESSAGE',
  ROLE_UPDATED: 'ROLE_UPDATED',
  SET_FIELDS_FOR_DROPDOWN: 'SET_FIELDS_FOR_DROPDOWN',
  SET_AREAS_FOR_DROPDOWN: 'SET_AREAS_FOR_DROPDOWN',
  SET_ALL_AREAS: 'SET_ALL_AREAS',
  SET_ALL_AREAS_USER_HAS_ACCESS_TO: 'SET_ALL_AREAS_USER_HAS_ACCESS_TO',
  CHANGE_SELECTED_FILTER: `CHANGE_SELECTED_FILTER`,
  CHANGE_TEMP_FILTER: `CHANGE_TEMP_FILTER`,
  LOAD_TASKTYPE_GROUPS_SUCCESS: `LOAD_TASKTYPE_GROUPS_SUCCESS`,
  SET_TASKTYPE_GROUPS_FOR_DROPDOWN: `SET_TASKTYPE_GROUPS_FOR_DROPDOWN`,
  TASKTYPES_GROUPS_SELECTED: `TASKTYPES_GROUPS_SELECTED`,
  UPSERT_AREAS: 'UPSERT_AREAS',
  SET_USER_CONFIG: 'SET_USER_CONFIG',
  SET_INITIAL_USER_CONFIG: 'SET_INITIAL_USER_CONFIG',
  SET_TENANT_STATUS_CONFIG: 'SET_TENANT_STATUS_CONFIG',
  UPSERT_API_TRIGGER_LIST: 'UPSERT_API_TRIGGER_LIST',
};

const INITIAL_API_REQUESTS = {
  getUserByUsername: 'getUserByUsername',
  getSettings: 'getSettings',
  getAllFields: 'getAllFields',
  getFieldTeams: 'getFieldTeams',
  getFieldTaskTypes: 'getFieldTaskTypes',
  getAllGlobalAttributes: 'getAllGlobalAttributes',
  getPackageInfo: 'getPackageInfo',
  getTaskTypeGroupPicklist: 'getTaskTypeGroupPicklist',
  getUserConfig: 'getUserConfig',
  getTenantStatusesConfig: 'getTenantStatusesConfig',
};

export const changeTempfilter = (tempFilter) => {
  return { type: types.CHANGE_TEMP_FILTER, tempFilter };
};

export function loadAreasForDropdown(field) {
  return (dispatch, getState) => {
    const { loggedInUser, selectedField, allAreas } = getState().appReducer;
    field = field || selectedField;
    const accessToFieldAndAreas = getFieldsAndAreasAccessibleToUser(loggedInUser);
    const accessToAllAreas = _.flatten(Object.values(accessToFieldAndAreas));
    const areasForDropdown = allAreas.filter((area) => area.fieldId === field.id && accessToAllAreas.includes(area.id));
    const savedAreaIdsInLocalStorage = getSelectedAreasInLocalStorage();
    const areasForDropdownDict = _.keyBy(areasForDropdown, 'id');
    const selectedAreas = savedAreaIdsInLocalStorage
      .map((id) => {
        if (areasForDropdownDict[id]) {
          return areasForDropdownDict[id];
        }
        return null;
      })
      .filter((val) => val);
    if (
      !_.isEqual(
        savedAreaIdsInLocalStorage,
        selectedAreas.map((val) => val.id)
      )
    ) {
      setSelectedAreasInLocalStorage(selectedAreas.map((val) => val.id));
    }
    dispatch({ type: types.SET_AREAS_FOR_DROPDOWN, areas: areasForDropdown });
    dispatch({ type: types.AREAS_SELECTED, areas: selectedAreas });
  };
}

function getAreasUserHasAccessTo(loggedInUser, allAreas) {
  const accessToFieldAndAreas = getFieldsAndAreasAccessibleToUser(loggedInUser);
  const accessToAllAreas = _.flatten(Object.values(accessToFieldAndAreas));
  const areasUserHasAccesTO = allAreas.filter((area) => accessToAllAreas.includes(area.id));
  return areasUserHasAccesTO;
}

export function loadTaskTypeGroupsForDropdown() {
  return (dispatch, getState) => {
    const { taskTypeGroups } = getState().appReducer;
    // need to add logic to restrict some of the tasktype groups depending on the role.
    // for now all taskTypeGroups are accessable
    const taskTypeGroupsAccessIds = taskTypeGroups.map((item) => item.id);
    const taskTypeGroupsForDropdown = taskTypeGroups.filter((item) => taskTypeGroupsAccessIds.includes(item.id));
    const selectedTaskTypeGroupsInLocalStorage = getSelectedTaskTypeGroupsInLocalStorage();
    const taskTypeGroupsDict = _.keyBy(taskTypeGroupsForDropdown, 'id');
    const selectedTaskTypeGroups = selectedTaskTypeGroupsInLocalStorage
      .map((id) => {
        if (taskTypeGroupsDict[id]) {
          return taskTypeGroupsDict[id];
        }
        return null;
      })
      .filter((val) => val);
    if (
      !_.isEqual(
        selectedTaskTypeGroupsInLocalStorage,
        selectedTaskTypeGroups.map((val) => val.id)
      )
    ) {
      setSelectedTaskTypeGroupsInLocalStorage(selectedTaskTypeGroups.map((val) => val.id));
    }
    dispatch({ type: types.SET_TASKTYPE_GROUPS_FOR_DROPDOWN, taskTypeGroups: taskTypeGroupsForDropdown });
    dispatch({ type: types.TASKTYPES_GROUPS_SELECTED, taskTypeGroups: selectedTaskTypeGroups });
  };
}

export function getAllTriggerApiList() {
  return async (dispatch) => {
    let triggerAPIList = [];
    try {
      const response = await apiService.getAllTriggerApi();
      const successResponse = _.get(response, 'data.rpcService.success');
      if (!successResponse) {
        throw response;
      }
      const res = _.get(response, 'data.rpcService.output') && JSON.parse(_.get(response, 'data.rpcService.output'));
      if (res) {
        triggerAPIList = res;
      } else {
        throw new Error('Vendors not found in api');
      }
    } catch (e) {
      logUtils.logError(e, 'Loading Vendors Failed');
    } finally {
      dispatch({ type: types.UPSERT_API_TRIGGER_LIST, triggerAPIList });
    }
  };
}

export function onFieldChange(field) {
  return async (dispatch, getState) => {
    const { selectedField } = getState().appReducer;
    if (selectedField.id === field.id) return;
    setSelectedFieldInLocalStorage(field.id);
    dispatch(loadAreasForDropdown(field));
    dispatch(loadTaskTypeGroupsForDropdown());
    dispatch({ type: types.FIELD_CHANGED, field });
    dispatch(loadUsersForField(field));
    dispatch(loadAllTeams(field.id));
    dispatch(loadAllTaskTypes(field.id));
  };
}

function areArraysEqual(arr1, arr2) {
  return _.xor(arr1, arr2).length === 0;
}

export function onAreaSelected(areaIds) {
  return (dispatch, getState) => {
    const state = getState();
    const {
      appReducer: { selectedAreas: prevSelectedAreas, areasForDropdown },
    } = state;
    const prevSelectedAreaIds = prevSelectedAreas.map((a) => a.id);

    if (!areArraysEqual(prevSelectedAreaIds, areaIds)) {
      const areaIdMap = _.keyBy(areasForDropdown, 'id');
      const selectedAreas = areaIds.map((id) => areaIdMap[id]);
      setSelectedAreasInLocalStorage(areaIds);
      dispatch({ type: types.AREAS_SELECTED, areas: selectedAreas });
    }
  };
}

export function onTaskTypeGroupSelected(taskTypeGroupIds) {
  return (dispatch, getState) => {
    const state = getState();
    const {
      appReducer: { selectedTaskTypeGroups: prevSelectedTaskTypeGroups, taskTypeGroupsForDropdown },
    } = state;
    const prevSelectedTaskTypeGroupIds = prevSelectedTaskTypeGroups.map((a) => a.id);

    if (!areArraysEqual(prevSelectedTaskTypeGroupIds, taskTypeGroupIds)) {
      const taskTypeGroupIdMap = _.keyBy(taskTypeGroupsForDropdown, 'id');
      const selectedTaskTypeGroups = taskTypeGroupIds.map((id) => taskTypeGroupIdMap[id]);
      setSelectedTaskTypeGroupsInLocalStorage(taskTypeGroupIds);
      dispatch({ type: types.TASKTYPES_GROUPS_SELECTED, taskTypeGroups: selectedTaskTypeGroups });
    }
  };
}

export function getSettings(tenantId) {
  return (dispatch) => {
    return apiService.getSettings(tenantId).then((response) => {
      dispatch({ type: types.SETTINGS_LOADED, data: response.data.getSettings });
    });
  };
}

export function updateSettings(key, settingsObject) {
  return (dispatch) => {
    return apiService.updateSettings(key, settingsObject).then((response) => {
      dispatch({ type: types.SETTINGS_UPDATED, data: response.data.updateSettings });
    });
  };
}

function validateLoggedInUser(loggedInUser) {
  const validationObj = {
    validationSuccessful: false,
    message: '',
    rootCause: '',
  };
  if (_.isNil(loggedInUser)) {
    validationObj.rootCause = 'getUserByUserName api return null value';
    validationObj.message = 'Invalid User';
    return validationObj;
  }

  if (!UserUtilites.isUserAdministrator(loggedInUser) && _.isNil(loggedInUser.fieldId)) {
    validationObj.rootCause = 'User is not Administrator and field is also not assigned to user';
    validationObj.message = 'You have not been assigned to any field';
    return validationObj;
  }

  if (UserUtilites.isUserVendor(loggedInUser) && !loggedInUser.vendorId) {
    validationObj.rootCause = 'User is vendor but vendorId has not been assigned to user';
    validationObj.message =
      'Your account does not have the required access permissions. Please contact your administrator';
    return validationObj;
  }

  if (_.isEmpty(loggedInUser.roleObjects)) {
    validationObj.rootCause = 'User does not have valid joyn2Roles array.';
    validationObj.message = 'Your account does not have necessary permission to access Joyn FSM';
    return validationObj;
  }

  if (_.isEmpty(UserUtilites.getFieldsAndAreasAccessibleToUser(loggedInUser))) {
    validationObj.rootCause = 'User does not have any role which has access to any field';
    validationObj.message = 'Your account does not have access to any field';
    return validationObj;
  }

  validationObj.validationSuccessful = true;

  return validationObj;
}

function findFieldAssignedToUser(user, allFields) {
  if (!allFields || !allFields.length) {
    throw new Error('Fields array is empty for this tenant');
  }
  const accessToFieldAndAreas = getFieldsAndAreasAccessibleToUser(user);
  const { fieldId } = user;
  const selectedFieldIdFromLocalStorage = getSelectedFieldInLocalStorage();
  const savedSelectedField =
    selectedFieldIdFromLocalStorage &&
    accessToFieldAndAreas[selectedFieldIdFromLocalStorage]?.length > 0 &&
    allFields.find((field) => field.id === selectedFieldIdFromLocalStorage);
  let defaultField = allFields.find((field) => accessToFieldAndAreas[field.id]?.length > 0);
  defaultField = defaultField || allFields.find((field) => !!accessToFieldAndAreas[field.id]);
  let fieldAssigned =
    fieldId && accessToFieldAndAreas[fieldId]?.length > 0 && allFields.find((field) => field.id === fieldId);
  fieldAssigned = savedSelectedField || fieldAssigned || defaultField;
  if (!fieldAssigned) throw new Error('No fields found for this user');
  if (fieldAssigned.id !== selectedFieldIdFromLocalStorage) {
    setSelectedFieldInLocalStorage(fieldAssigned.id);
  }
  fieldAssigned = fieldAssigned || defaultField;
  if (!fieldAssigned) throw new Error('No fields found for this user');
  return fieldAssigned;
}

function loadFieldsForDropdown(fields) {
  return (dispatch, getState) => {
    const { loggedInUser } = getState().appReducer;
    const accessToFieldAndAreas = getFieldsAndAreasAccessibleToUser(loggedInUser);
    const fieldsForDropdown = fields.filter((field) => !!accessToFieldAndAreas[field.id]);
    dispatch({ type: types.SET_FIELDS_FOR_DROPDOWN, fields: fieldsForDropdown });
  };
}

function getTenantStatusConfig(tenantStatusConfigInfo) {
  const statusConfigInfoMap = _.keyBy(tenantStatusConfigInfo, 'name');
  const statusConfigUI = STATUS_LIST; // this is getting updated
  Object.values(statusConfigUI).forEach((item) => {
    if (statusConfigInfoMap[item.key]) {
      item.text = statusConfigInfoMap[item.key].displayName;
    }
  });
  return statusConfigUI;
}

export function loadAllAreas() {
  return async (dispatch, getState) => {
    const { loggedInUser } = getState().appReducer;
    const response = await apiService.searchAssets({ type: { match: 'area' } });
    const areaResponse = response.data.searchAssets.items?.sort((a1, a2) => a1.name.localeCompare(a2.name));
    const allAreasUserHasAccessTo = getAreasUserHasAccessTo(loggedInUser, areaResponse);
    dispatch({ type: types.SET_ALL_AREAS, areas: areaResponse });
    dispatch({ type: types.SET_ALL_AREAS_USER_HAS_ACCESS_TO, allAreasUserHasAccessTo });
    return { areaResponse, allAreasUserHasAccessTo };
  };
}

export function bulkDownloadInitialData({ tenantId }) {
  return async (dispatch) => {
    dispatch({ type: types.LOADING_INITIAL_DATA });
    try {
      const responseObject = await apiService.bulkDownloadInitialData({
        requests: [
          INITIAL_API_REQUESTS.getUserByUsername,
          INITIAL_API_REQUESTS.getSettings,
          INITIAL_API_REQUESTS.getAllFields,
          INITIAL_API_REQUESTS.getAllGlobalAttributes,
          INITIAL_API_REQUESTS.getPackageInfo,
          INITIAL_API_REQUESTS.getTaskTypeGroupPicklist,
          INITIAL_API_REQUESTS.getUserConfig,
          INITIAL_API_REQUESTS.getTenantStatusesConfig,
        ],
      });
      const loggedInUser = responseObject[INITIAL_API_REQUESTS.getUserByUsername];

      const validationObj = validateLoggedInUser(loggedInUser);
      if (!validationObj.validationSuccessful) {
        throw validationObj;
      }
      logUtils.configureUserScopeInErrorLoggingService({ id: loggedInUser.id });
      const allFields = responseObject[INITIAL_API_REQUESTS.getAllFields];
      const taskTypeGroupPicklist = responseObject[INITIAL_API_REQUESTS.getTaskTypeGroupPicklist] || {};
      const taskTypeGroups = Object.values(taskTypeGroupPicklist?.options || {});
      const fieldAssignedToUser = findFieldAssignedToUser(loggedInUser, allFields);
      let userConfig = (responseObject[INITIAL_API_REQUESTS.getUserConfig] || [])[0];
      const tenantStatusConfigInfo = responseObject[INITIAL_API_REQUESTS.getTenantStatusesConfig] || {};
      dispatch({ type: types.SET_TENANT_ID, tenantId });
      dispatch({ type: types.LOAD_FIELDS_SUCCESS, fields: allFields });
      dispatch({ type: types.LOAD_TASKTYPE_GROUPS_SUCCESS, taskTypeGroups });
      dispatch({ type: types.SETTINGS_LOADED, data: responseObject[INITIAL_API_REQUESTS.getSettings] });
      dispatch({ type: types.PACKAGES_INFO_LOADED, data: responseObject[INITIAL_API_REQUESTS.getPackageInfo] });
      dispatch({ type: types.FIELD_CHANGED, field: fieldAssignedToUser });
      dispatch({ type: types.SET_LOGGED_IN_USER, user: loggedInUser });
      if (!userConfig) {
        const userConfigResponse = await apiService.upsertConfigForUser(
          makeInitialUserConfig(loggedInUser.id, tenantId)
        );
        userConfig = _.get(userConfigResponse, 'data.rpcService.output');
        userConfig = userConfig ? JSON.parse(userConfig) : null;
      }

      dispatch({ type: types.SET_USER_CONFIG, userConfig });
      dispatch({ type: types.SET_INITIAL_USER_CONFIG, userConfig });

      dispatch({
        type: types.SET_TENANT_STATUS_CONFIG,
        statusConfig: getTenantStatusConfig(tenantStatusConfigInfo),
      });

      // dispatch({
      //   type: types.CHANGE_TEMP_FILTER,
      //   tempFilter: JSON.parse(userConfig?.TASK_LIST?.[LOCAL_STORAGE_TASK_LIST_TEMP_FILTER] || '{}'),
      // });
      dispatch({
        type: types.CHANGE_SELECTED_FILTER,
        selectedFilter: JSON.parse(userConfig?.TASK_LIST?.[LOCAL_STORAGE_TASK_LIST_FILTER_MODEL] || '{}'),
      });

      dispatch(loadFieldsForDropdown(allFields));
      const newResponseObject = await apiService.bulkDownloadInitialData({
        requests: [INITIAL_API_REQUESTS.getFieldTeams, INITIAL_API_REQUESTS.getFieldTaskTypes],
        fieldId: fieldAssignedToUser.id,
        userId: loggedInUser.id,
      });
      dispatch({
        type: teamActionTypes.LOAD_TEAM_LIST_SUCCESS,
        teamList: newResponseObject[INITIAL_API_REQUESTS.getFieldTeams],
      });
      dispatch({
        type: taskTypeActionTypes.LOAD_TASK_TYPES_SUCCESS,
        taskTypes: newResponseObject[INITIAL_API_REQUESTS.getFieldTaskTypes],
      });
      dispatch(loadUsersForField(fieldAssignedToUser));

      // required filter at componentdidmount of tasklist
      dispatch(getAllTriggerApiList());
      dispatch(loadSavedFiltersOfUser(loggedInUser.id));
      await dispatch(loadAllAreas());
      dispatch(loadAreasForDropdown());
      dispatch(loadTaskTypeGroupsForDropdown());
      dispatch(loadGlobalAttributes(responseObject[INITIAL_API_REQUESTS.getAllGlobalAttributes]));
      
    } catch (e) {
      const isTimeOutError = _.get(e, 'errors[0].errorType') === 'ExecutionTimeout';
      let errorMessage;
      if (isTimeOutError) {
        errorMessage = 'Request Time Out Error';
      } else {
        errorMessage = (!(e instanceof Error) && e.message) || 'Could not load initial data';
      }
      logUtils.logError(e, errorMessage);
      dispatch({ type: types.SHOW_ERROR_MESSAGE, errorMessage });
    } finally {
      dispatch({ type: types.HIDE_LOADER });
    }
  };
}

export function updateSignature(signatureObject) {
  return async (dispatch, getState) => {
    const {
      appReducer: { loggedInUser },
    } = getState();
    const userToBeUpdated = {
      id: loggedInUser.id,
      signatureObject,
    };
    const updatedUserResponse = await apiService.updateUser(userToBeUpdated);
    const updatedUser = _.get(updatedUserResponse, 'data.updateUser');
    if (updatedUser) {
      const newUser = { ...loggedInUser, ...userToBeUpdated };
      dispatch({ type: types.SET_LOGGED_IN_USER, user: newUser });
    }
  };
}

export function changeFilter(selectedFilter) {
  return (dispatch) => {
    dispatch(changeSelectedFilter(selectedFilter));
  };
}

export function upsertAreas(updatedAreas = []) {
  return async (dispatch) => {
    dispatch({ type: types.UPSERT_AREAS, updatedAreas });
  };
}

export function updateUserConfig(path, valueObj) {
  return async (dispatch, getState) => {
    const {
      appReducer: { userConfig },
    } = getState();

    const pathNewValue = { ...userConfig[path], ...valueObj };

    const newConfig = {
      ...userConfig,
      [path]: pathNewValue,
    };

    dispatch({ type: types.SET_USER_CONFIG, userConfig: newConfig });

    await apiService.upsertConfigForUser(newConfig);
  };
}

export function updateInitialUserConfig() {
  return async (dispatch, getState) => {
    const {
      appReducer: { userConfig },
    } = getState();

    dispatch({ type: types.SET_INITIAL_USER_CONFIG, userConfig });
  };
}
